import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import parse from 'html-react-parser';
import axios from 'axios';

function BlogDetail() {
    const[blog,setBlog]=useState(null)

    const {id}=useParams()

    useEffect(()=>{
if(id){
    console.log("id",id)
    getCurrentBlogDetail()
}
    },[id])

    const getCurrentBlogDetail=()=>{
        axios
        .get(`http://localhost:52712/api/Admin/GETBlogs?id=${id}`, {
          headers: {
          //   Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          console.log(response.data.data)
          setBlog(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }

  return (
    <section>
<div class="page-wrapper">
    {blog && blog.length>0?
    blog.map((blog,idx)=>{
        return <div>{parse(blog.Content)}</div>

    })
:
    null
    }
</div>

<button class="scroll-top scroll-to-target" data-target="html">
    <span class="fa fa-arrow-up"></span>
</button>
    </section>
  )
}

export default BlogDetail

    